import { InjectionToken } from '@angular/core';

export const GOOGLE_ANALYTICS_SETTINGS_TOKEN = new InjectionToken('google-analytics-settings', {
    factory: () => ({ trackingCode: '', adsCode: '', phoneTrackingID: '', phoneTrackingNumber: '', initCommands: [], isEnabled: true })
});
